
<div mat-dialog-title class="w-100">
    <div
        class="title d-flex align-items-center justify-content-space-between pop-up-header head"
    >
        <h4 class="mb-0 pop-up-text">
          
        </h4>
        <button
            class="close-button"
            (click)="close()"
        >
            <i class="flaticon-close"></i>
        </button>
    </div>
</div>
<div class="body">
    <div class="email-container">       
        <p>Dear team,</p>
        
        <p>Please note the for {{this.data?.universityName}} student needs to sign Agent consent form.</p>
        
        <div class="important">
            <p>Please note a electronic form will go to student {{this.data?.email}} email id.</p>
            <p>Please ask to student to login to their email & electronically sign it without this application cannot be processed as per university.</p>
        </div>
    </div>
    <div class="button-container">
        <button class="continue-button" (click)="onContinue()">Continue</button>
    </div>
</div>
